export const ADD_ITEM_TO_CART = "cart/addItem";
export const REMOVE_ITEM_FROM_CART = "cart/removeItem";
